import { render, staticRenderFns } from "./index.vue?vue&type=template&id=230329ae&scoped=true"
import script from "./formButtons.js?vue&type=script&lang=js&external"
export * from "./formButtons.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=230329ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230329ae",
  null
  
)

export default component.exports